import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ConflictSetting, ShiftPlanFormValue } from '@wilson/interfaces';

import { add } from 'date-fns';
import {
  ResetShiftPlanDuplicateForm,
  SetShiftPlanDuplicateFormAction,
  ShiftPlanSplitMeta,
} from './shift-planning-data.actions';

export interface ShiftPlanningDataStateModel {
  duplicateShiftPlanForm: ShiftPlanFormValue;
  isShiftPlanDuplicate: boolean;
  splitMeta: ShiftPlanSplitMeta | null;
}
export const defaults: ShiftPlanningDataStateModel = {
  duplicateShiftPlanForm: {
    totalDays: 0,
    header: {
      name: '',
      dateRange: [new Date(), add(new Date(), { days: 7 })],
      rolling: false,
      conflictSetting: ConflictSetting.Assign,
      orgUnit: '',
    },
    calendar: {
      shiftPlanUsers: [],
      shiftPlanTemplates: [],
    },
  },
  isShiftPlanDuplicate: false,
  splitMeta: null,
};

@State({
  name: 'shiftPlanningData',
  defaults,
})
@Injectable()
export class ShiftPlanningDataState {
  @Selector()
  static duplicateForm(state: ShiftPlanningDataStateModel) {
    return state.duplicateShiftPlanForm;
  }

  @Selector()
  static isShiftPlanDuplicate(state: ShiftPlanningDataStateModel) {
    return state.isShiftPlanDuplicate;
  }

  @Selector()
  static splitMeta(state: ShiftPlanningDataStateModel) {
    return state.splitMeta;
  }

  @Action(SetShiftPlanDuplicateFormAction)
  setDuplicateShiftPlanForm(
    ctx: StateContext<ShiftPlanningDataStateModel>,
    action: SetShiftPlanDuplicateFormAction,
  ) {
    ctx.patchState({
      duplicateShiftPlanForm: action.shiftPlanForm,
      isShiftPlanDuplicate: true,
      splitMeta: action.split ?? null,
    });
  }

  @Action(ResetShiftPlanDuplicateForm)
  resetShiftPlanDuplicateForm(ctx: StateContext<ShiftPlanningDataStateModel>) {
    ctx.patchState(defaults);
  }
}
